import { configureStore, combineReducers } from '@reduxjs/toolkit';
import newsReducer from './slices/newsSlice';
import rateLimitReducer from './slices/rateLimitSlice';

const rootReducer = combineReducers({
  news: newsReducer,
  rateLimit: rateLimitReducer,
  // ...
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
